import { render, staticRenderFns } from "./contratosPendentes.vue?vue&type=template&id=60e4aa94"
import script from "./contratosPendentes.vue?vue&type=script&lang=js"
export * from "./contratosPendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports